import Vue from 'vue';
import Router from 'vue-router';
/* Layout */
import Layout from '@/platform/index.vue';
import searchPlatform from '@/platform/Platform.vue';
import RNPLayout from '@/platform/RNPLayout.vue';
import VcardLayout from '@/platform/VcardLayout.vue';
import i18n from '@/lang';
Vue.use(Router);

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      component: Layout,
      children: [{
        path: '',
        name: 'photography',
        component: () => import('@/views/photography/index.vue'),
        meta: {
          photography: true
        }
      }, {
        path: 'admin',
        name: 'admin',
        component: () => import('@/views/admin.vue')
      }, {
        path: 'photography/:id',
        name: 'photographyList',
        component: () => import('@/views/photography/list.vue'),
        meta: {
          photography: true
        }
      }
      // {
      //   path: ':id/:cid',
      //   name: 'photographyDetail',
      //   component: () => import('@/views/photography/detail.vue'),
      //   meta: {
      //     photography: true
      //   }
      // }
      ]
    },
    // {
    //   path: '/',
    //   component: Layout,
    //   children: [
    //     {
    //       path: '',
    //       name: 'home',
    //       component: () => import('@/views/home.vue')
    //     },
    //     {
    //       path: 'admin',
    //       name: 'admin',
    //       component: () => import('@/views/admin.vue')
    //     },
    //     {
    //       path: 'SearchPlatform',
    //       name: 'SearchPlatform',
    //       component: () => import('@/views/cms/searchPlatform.vue')
    //     },
    //     {
    //       path: 'download',
    //       name: 'download',
    //       component: () => import('@/views/cms/download.vue')
    //     },
    //     {
    //       path: 'leaflet',
    //       name: 'leaflet',
    //       component: () => import('@/views/cms/leaflet.vue')
    //     }, {
    //       path: 'Realcases',
    //       name: 'Realcases',
    //       component: () => import('@/views/cms/RealSystem.vue')
    //     }, {
    //       path: 'esgworldrecord2024',
    //       name: 'esgworldrecord2024',
    //       component: () => import('@/views/photo/NewphotoList.vue')
    //     }, {
    //       path: 'systems',
    //       name: 'systems',
    //       component: () => import('@/views/cms/Sys.vue')
    //     }, {
    //       path: 'ESG',
    //       name: 'ESG',
    //       component: () => import('@/views/cms/ESG.vue')
    //     },
    //     {
    //       path: 'esgEvents',
    //       name: 'esgEvents',
    //       component: () => import('@/views/cms/esgEvents.vue')
    //     }
    //   ]
    // },
    {
      path: '/building',
      name: 'building',
      component: () => import('@/views/building.vue')
    },
    {
      path: '/regnpay',
      component: RNPLayout,
      children: [{
        path: '',
        name: 'regnpay',
        component: () => import('@/views/regNPay/index.vue'),
        children: [{
          path: 'form/:id',
          name: 'regNPayForm',
          component: () => import('@/views/regNPay/regNPayForm.vue')
        }, {
          path: 'result/:id',
          name: 'regNPayResult',
          component: () => import('@/views/regNPay/regNPayResult.vue')
        }]
      }]
    },
    {
      path: '',
      component: VcardLayout,
      children: [{
        path: '/vcard/:key',
        name: 'vcard',
        component: () => import('@/views/vcard/vcard.vue')
      }, {
        path: 'daisy',
        name: 'daisy',
        component: () => import('@/views/vcard/daisy.vue')
      }, {
        path: 'Ivy',
        name: 'Ivy',
        component: () => import('@/views/vcard/Ivy.vue')
      }, {
        path: 'sofia',
        name: 'sofia',
        component: () => import('@/views/vcard/sofia.vue')
      }, {
        path: 'Hoyee',
        name: 'Hoyee',
        component: () => import('@/views/vcard/Hoyee.vue')
      }, {
        path: 'kennis',
        name: 'kennis',
        component: () => import('@/views/vcard/Kennis.vue')
      }, {
        path: 'Wing',
        name: 'Wing',
        component: () => import('@/views/vcard/Wing.vue')
      }, {
        path: 'Nyx',
        name: 'Nyx',
        component: () => import('@/views/vcard/Nyx.vue')
      }]
    },
    {
      path: '/payment',
      component: RNPLayout,
      children: [{
        path: 'PaySuccess/:id',
        name: 'PaySuccess',
        component: () => import('@/views/payment/paySuccess.vue')
      }, {
        path: 'PayFail/:id',
        name: 'PayFail',
        component: () => import('@/views/payment/payFail.vue')
      }]
    },
    // {
    //   path: '/cms/SearchPlatform',
    //   component: searchPlatform,
    //   children: [{
    //     path: 'SearchPlatform',
    //     name: 'SearchPlatform',
    //     component: () => import('@/views/cms/searchPlatform.vue')
    //   }]
    // },
    {
      path: '/cms',
      component: Layout,
      children: [{
        path: 'content/:id',
        name: 'cmsContent',
        component: () => import('@/views/cms/content.vue'),
        meta: {
          photography: true
        }
      },
      {
        path: 'normal/:id',
        name: 'normal',
        component: () => import('@/views/cms/normal.vue')
      },
      {
        path: 'vr/:id',
        name: 'vr',
        component: () => import('@/views/cms/vr.vue')
      },
      {
        path: 'songdirection/:id',
        name: 'vr',
        component: () => import('@/views/cms/songdirection.vue')
      },
      {
        path: 'catDetail/:id',
        name: 'cmsCatDetail',
        component: () => import('@/views/cms/catDetail.vue')
      }, {
        path: 'payme',
        name: 'payme',
        component: () => import('@/views/cms/payme.vue')
      },
      {
        path: 'paypal',
        name: 'paypal',
        component: () => import('@/views/cms/paypal.vue')
      },
      {
        path: 'paymentAsia',
        name: 'paymentAsia',
        component: () => import('@/views/cms/paymentAsia.vue')
      },
      {
        path: 'contentNew/:id',
        name: 'contentNew',
        component: () => import('@/views/cms/contentN.vue')
      },
      {
        path: 'songDetail/:id',
        name: 'songDetail',
        component: () => import('@/views/cms/songDetail.vue')
      },
      {
        path: 'search/:key',
        name: 'search',
        component: () => import('@/views/cms/search.vue')
      }, {
        path: 'emf',
        name: 'emf',
        component: () => import('@/views/cms/emf.vue')
      }, {
        path: 'tvp',
        name: 'tvp',
        component: () => import('@/views/cms/tvp.vue')
      }, {
        path: 'bud',
        name: 'bud',
        component: () => import('@/views/cms/bud.vue')
      }, {
        path: 'easybud',
        name: 'easybud',
        component: () => import('@/views/cms/easybud.vue')
      }, {
        path: 'digital',
        name: 'digital',
        component: () => import('@/views/cms/digital.vue')
      }, {
        path: 'Nifs',
        name: 'Nifs',
        component: () => import('@/views/cms/Nifs.vue')
      }, {
        path: 'ECommerceEasy',
        name: 'ECommerceEasy',
        component: () => import('@/views/cms/ECommerceEasy.vue')
      }, {
        path: 'CustomerReview/:id',
        name: 'CustomerReview',
        component: () => import('@/views/cms/CustomerReview.vue')
      }, {
        path: 'Intern',
        name: 'Intern',
        component: () => import('@/views/cms/Intern.vue')
      }, {
        path: 'AuditChill',
        name: 'AuditChill',
        component: () => import('@/views/cms/AuditChill.vue')
      },
      {
        path: 'GovernmentFunding',
        name: 'GovernmentFunding',
        component: () => import('@/views/cms/GovernmentFunding.vue')
      },
      {
        path: 'SLA',
        name: 'SLA',
        component: () => import('@/views/cms/SLA.vue')
      },
      {
        path: 'Advertising',
        name: 'Advertising',
        component: () => import('@/views/cms/Advertising.vue')
      },
      {
        path: 'NetLearnPlus',
        name: 'NetLearnPlus',
        component: () => import('@/views/cms/NetLearnPlus.vue')
      }
    ]
    },
    {
      path: '/event',
      component: Layout,
      children: [{
        path: 'list/:date',
        name: 'eventList',
        component: () => import('@/views/event/eventList.vue')
      }, {
        path: 'detail/:id',
        name: 'eventDetail',
        component: () => import('@/views/event/eventDetail.vue')
      }]
    },
    {
      path: '/photo',
      component: Layout,
      children: [{
        path: 'album',
        name: 'photoAlbum',
        component: () => import('@/views/photo/photoAlbum.vue')
      },
      {
        path: 'list/:id',
        name: 'photoList',
        component: () => import('@/views/photo/photoListN.vue')
      }]
    },
    {
      path: '/account',
      component: Layout,
      children: [{
        path: 'login',
        name: 'register',
        component: () => import('@/views/account/InsLoginN.vue'),
        meta: {
          photography: true
        }
      }, {
        path: 'forgetPassword',
        name: 'forgetPassword',
        component: () => import('@/views/account/InsForgetPassword.vue'),
        meta: {
          photography: true
        }
      }, {
        path: 'ResetPwd/:id/:code',
        name: 'ResetPwd',
        component: () => import('@/views/account/InsResetPwd.vue'),
        meta: {
          photography: true
        }
      }
    ]
    }
  ],
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition; // 返回时恢复原位置‌:ml-citation{ref="4,6" data="citationList"}
    } else {
      return { x: 0, y: 0 }; // 新页面跳转时滚动到顶部‌:ml-citation{ref="1,5" data="citationList"}
    }
  }
});

export default router;
router.beforeEach((to, from, next) => {
  if (to.matched.length === 0) { // 如果未匹配到路由
    // SEO判斷處理
    let lang = to.path.toLowerCase().match(/\/en|\/xc|\/tc/i);

    if (lang) {
      let transLang;
      switch (lang[0]) {
        case '/en':
          transLang = 'E';
          break;
        case '/xc':
          transLang = 'S';
          break;
        case '/tc':
          transLang = 'C';
          break;
      }

      i18n.locale = transLang;

      next({
        path: to.path.replace(lang[0], '')
      });
    } else {
      from.name ? next({ name: from.name }) : next('/'); // 如果上級也未匹配到路由則跳轉首頁，如果上級能匹配到則轉上級路由
    }
  }

  if (from.name) {
    Vue.prototype.$ShowLayer();
    next();
    setTimeout(() => {
      Vue.prototype.$HiddenLayer();
    }, 500);
  } else {
    setTimeout(function () {
      next();
    }, 200);
  }
});
